import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ModelCombobox from '@/components/model-combobox';
import TaskCombobox from '@/components/task-combobox';
import DatePicker from '@/components/ui/date-picker';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import UserCombobox from '@/components/user-combobox';
import { useFormSearchParams } from '@/hooks/use-form-search-params';
import type { StatisticsFiltersSchema } from '@/routes/(app)/(statistics)/lib/schema';

const StatisticsFilters = () => {
  const { t } = useTranslation();
  const form = useFormContext<StatisticsFiltersSchema>();
  useFormSearchParams('/app/statistics/$statistic');

  return (
    <div className='flex flex-row gap-4'>
      <FormField
        control={form.control}
        name='task'
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('statistics.filters.task')}</FormLabel>
            <FormControl>
              <TaskCombobox {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name='model'
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('statistics.filters.model')}</FormLabel>
            <FormControl>
              <ModelCombobox {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name='date'
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('statistics.filters.date')}</FormLabel>
            <FormControl>
              <DatePicker
                {...field}
                mode='range'
                selected={{
                  from: field.value?.from
                    ? new Date(field.value.from)
                    : undefined,
                  to: field.value?.to ? new Date(field.value.to) : undefined,
                }}
                onSelect={(range) => {
                  field.onChange({
                    from: range?.from ?? undefined,
                    to: range?.to ?? undefined,
                  });
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name='createdBy'
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('statistics.filters.createdBy')}</FormLabel>
            <FormControl>
              <UserCombobox {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default StatisticsFilters;
